import { render } from "./AppToggle.vue?vue&type=template&id=126a319a&scoped=true"
import script from "./AppToggle.vue?vue&type=script&lang=js"
export * from "./AppToggle.vue?vue&type=script&lang=js"

import "./AppToggle.vue?vue&type=style&index=0&id=126a319a&scoped=true&lang=scss"

import exportComponent from "/Users/michellmonroy/Documents/dev-glider/catalogue-api/node_modules/vue-loader-v16/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render],['__scopeId',"data-v-126a319a"]])

export default __exports__